import sessionSaga from './SessionSaga';
import orderSaga from './OrderSaga';
import historySaga from './HistorySaga';
import editDishSaga from './EditDishSaga';
import CheckoutSaga from './CheckoutSaga';
import PayPerDishSaga from './PayPerDishSaga';
import OrderHistorySaga from './OrderHistorySaga.js';

export default [sessionSaga, orderSaga, historySaga, editDishSaga, CheckoutSaga, PayPerDishSaga, OrderHistorySaga];
